export default __webpack_public_path__ + "60e274126f12b2a43d651630ee63e5b6.ico";